import { createActionHistory } from './action-history';
export const actionHistory = createActionHistory({ limit: 30, exclude: '^@@redux-form/.*|CLIENT_CLOUD_LOG' });
